// extracted by mini-css-extract-plugin
module.exports = {"sdsButton":"buttons_sdsButton__D7K92","primaryButton":"PrimaryButton_primaryButton__PsagO buttons_sdsButton__D7K92"};